<template>
  <div id="top">
    <section class="speaker-detail-wrapper">
      <div class="speaker-detail">
        <div class="container">
          <div class="row">
            <div class="col-md-3">
              <div class="image-wrapper">
                <img v-if="avatar == null || avatar == 'https://www.dmgeventsconferences.com/'"
                  src="https://www.futureenergyasia.com/media/7674/speaker-default.jpg" alt="Mark McDougall  300x300">
                <img class="img-fluid" v-else :srcset="avatar">
              </div>
            </div>
            <div class="col-md-9">
              <div class="content">
                <div v-if="eventname == 'japan'">
                  <img style="max-width:100px;max-height:auto;margin-top:5px" v-if="eventname == 'japan' && companyLogo !== null && companyLogo !== undefined && companyLogo !== ''" :src="companyLogo" :alt="company"/>
                </div>
                <h3>{{ name }}</h3>
                <h5>{{ jobTitle }}</h5>
                <h6>{{ company }}</h6>
                <p>{{ country }}</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 speaker-bio">
              <p>{{ biography }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
//import $ from 'jquery';
import axios from "axios";
import url from "./../../config/url";
export default {
  name: "ExhibitorProfilePage",
  data: function () {
    return {
      exhibitorid: this.$route.query.userId,
      id: null,
      name: null,
      jobTitle: null,
      company: null,
      biography: null,
      avatar: null,
      country: null,
      companyLogo:null,
      eventname:''
    };
  },
  mounted() {
    this.exhibitorDetails(this.exhibitorid);
    const url = window.location.href;
    const domain = url.split('/')[2];
    if (domain === "www.futureenergyasia.com") {
      this.eventname = "fea";
    } else if (domain === "www.future-mobility.asia") {
      this.eventname = "fma";
    } else if (domain === "www.japanenergyevent.com/") {
      this.eventname = "japan";
    }else if (domain === "www.gastechevent.com") {
      this.eventname = "gastech";
    } else {
      this.eventname = "japan";
    }
  },
  methods: {
    exhibitorDetails: function (eId) {
      // debugger
      axios
        .get(url.user_detail_api, { params: { Userid: eId } })
        .then(response => {
          //    debugger
          this.id = response.data[0].id;
          this.name = response.data[0].name;
          this.jobTitle = response.data[0].jobTitle;
          this.company = response.data[0].company;
          this.biography = response.data[0].biography;
          this.avatar = response.data[0].avatar;
          this.country = response.data[0].country;
          this.companyLogo = response.data[0].companyLogo;
        })
        .catch(error => {
          console.log(error);
        });
      window.scrollTo(0, 0);
    },

    exhibitorProductData: function () {
      (this.showProductCategory = true),
        (this.showPressRelease = false),
        (this.showBrochure = false);
    },
    exhibitorPressReleaseData: function () {
      (this.showProductCategory = false),
        (this.showPressRelease = true),
        (this.showBrochure = false);
    },
    exhibitorBrochuresData: function () {
      (this.showProductCategory = false),
        (this.showPressRelease = false),
        (this.showBrochure = true);
    }
  }
};





</script>
